export const calendarIcon = require('@assets/icons/calendar.webp');
export const downIcon = require('@assets/icons/down.webp');
export const bettingIcon = require('@assets/icons/rebate/betting.webp');
export const rebateIcon = require('@assets/icons/rebate/rebate.webp');
export const closeIcon = require('@assets/icons/close-white.webp');
